var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blogTableOfContents"},[_c('div',{staticClass:"blogTableOfContents__title"},[_vm._v("Spis treści")]),_vm._v(" "),_c('ol',{staticClass:"blogTableOfContents__list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"blogTableOfContents__listItem"},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to"}],staticClass:"blogTableOfContents__link",attrs:{"href":`#${_vm.slugify(item, {
          lower: true,
          strict: true,
        })}`},domProps:{"innerHTML":_vm._s(item)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }